module.exports = __webpack_public_path__ + "assets/icons/calendar-question-e3de.svg";